import {apiFetch} from './api.js'
import { setAccessToken } from './auth.js'

export const userRegister = async(name_user, password_user, email_user, rol_user, phone_number_user, team_id) => {
    const endPoint = process.env.REACT_APP_URL_REGISTER
    try {
        const response = await apiFetch(endPoint, {
            method: "POST",
            body: JSON.stringify(
                { 
                    name_user,
                    email_user,
                    password_user,
                    rol_user, 
                    phone_number_user,
                    team_id
                }),
        })

        const data = await response.json()
        if(!data.ok) throw new Error(data.message)

        return data
    }catch(err){
        console.error(err)
    }
}

export const userLogin = async(name_user, password_user) => {
    const endPoint = process.env.REACT_APP_URL_LOGIN

    try {
        const response = await fetch(endPoint, {
            method: "POST",
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name_user, password_user }),
        })

        if(!response.ok) throw  new Error(data.message)
        
        const data = await response.json()       
        setAccessToken(data.accessToken)
        return data.user
    }catch(err){
        return { ok: false, message: "error en la peticion" };
    }
}

export const verifyUser = async() => {
    const endPoint = process.env.REACT_APP_URL_STATUS

    try{
        const response = await apiFetch(endPoint)

        const data = await response.json()

        if(!response.ok) return {status: false}

        return {
            status: true,
            user_id: data.user.user_id,
            name_user: data.user.name_user,
            rol_user: data.user.rol_user,
            phone_number_user: data.phone_number_user
        }
    }catch(err){
        console.error(err)
    }
}

export const logoutUser = async() => {
    const endPoint = process.env.REACT_APP_URL_LOGOUT

    try{
        setAccessToken(null)
        const response = await apiFetch(endPoint)
        const data = await response.json()
        return data
    }catch(err){
        console.error(err)
    }
}